import SignInContainer from './components/sign-in-container'
import SignInFormContainer from './components/sign-in-form-container'
import SignInSubmitButton from './components/sign-in-submit-button'
import SignInFooter from './components/sign-in-footer'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import FormInputPassword from './components/form-input-password'
import SignInBackButton from './components/sign-in-back-button'
import { updatePassword } from '../../hooks/getAuth'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { signInInputSchema } from './data/sign-in-schema'
interface Props {
  email: string
  oldPassword: string
  onSuccess: (data: any) => void
  onClickBack: () => void
}

const formSchema = z
  .object({
    email: signInInputSchema.shape.email,
    password: signInInputSchema.shape.password,
    confirmPassword: signInInputSchema.shape.confirmPassword,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  })

type FormValues = z.infer<typeof formSchema>

export default function SignInUpdatePassword({
  email,
  oldPassword,
  onSuccess,
  onClickBack,
}: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email,
    },
  })

  const { mutate, isPending } = useMutation({
    mutationFn: (data: FormValues) =>
      updatePassword(data.email, oldPassword, data.password),
    onSuccess: (data: any) => onSuccess(data),
    onError: (error: any) => toast.warn(error.message),
  })

  const onSubmit = (data: FormValues) => mutate(data)

  return (
    <SignInContainer loading={isPending}>
      <SignInFormContainer title="Update Password">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex space-y-4 flex-col py-4">
            <div className="py-4 flex flex-col space-y-4">
              <FormInputPassword
                placeholder="Password"
                register={register('password')}
                error={errors.password}
              />

              <FormInputPassword
                placeholder="Confirm Password"
                register={register('confirmPassword')}
                error={errors.confirmPassword}
              />
            </div>

            <SignInSubmitButton text="Update Password" />
            <SignInBackButton onClick={onClickBack} />
          </div>
        </form>
      </SignInFormContainer>
      <SignInFooter />
    </SignInContainer>
  )
}
